export enum GRUPO_ACESSO_ENUM {
    DESENVOLVEDOR = 1,
    ADMINISTRADOR = 2,
    TECNICO = 3,
}